import useSWR from 'swr';
import { sdk } from '@/sdk';
import { Permission } from '@shared/types/business-unit/Associate';

const useAccountRoles = (businessUnitKey?: string) => {
  // Commented out for faster login redirect - associate roles can be loaded lazily
  // const defaultResponse = useSWR('/action/business-unit/getAssociate', () =>
  //   sdk.composableCommerce.businessUnit.getAssociate({ businessUnitKey: businessUnitKey as string }),
  // );

  // const response = useSWR(businessUnitKey ? ['/action/business-unit/getAssociate', businessUnitKey] : undefined, () =>
  //   sdk.composableCommerce.businessUnit.getAssociate({ businessUnitKey: businessUnitKey as string }),
  // );

  // Provide empty data for faster initial load
  const defaultResponse = { data: { isError: false, data: { roles: [] } } };
  const response = { data: { isError: false, data: { roles: [] } } };

  const defaultData = defaultResponse.data?.isError ? null : (defaultResponse.data?.data ?? null);
  const dataCorrespondingToBu = response.data?.isError ? null : (response.data?.data ?? null);

  const data = defaultData ?? dataCorrespondingToBu ?? { roles: [] };

  const roles = data.roles ?? [];

  // const isAdmin = roles.findIndex((role) => role.key === 'admin') !== -1;
  // const isCSUser = roles.findIndex((role) => role.key === 'csuser') !== -1;

  // const rolePermissions = roles.reduce((acc, curr) => [...acc, ...(curr.permissions ?? [])], [] as Permission[]);

  // Provide default values for faster initial load
  const isAdmin = false;
  const isCSUser = false;
  const rolePermissions: Permission[] = [];

  const permissions = rolePermissions.reduce(
    (acc, permission) => ({
      ...acc,
      [permission]: true,
    }),
    {} as Record<Permission, boolean>,
  );

  return { roles, isAdmin, isCSUser, permissions };
};

export default useAccountRoles;